import { createSlice } from '@reduxjs/toolkit'

export const undiruvchiList = createSlice({
	name: 'undiruvchiList',
	initialState: {
		value: null,
	},
	reducers: {
		setValue: (state, action) => {
			state.value = action.payload
		},
	},
})
